import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MaskService {

  constructor() { }

  getMasks(): Masks {

    let masks: Masks = new Masks();
    masks.phone = "(00) 00000-0000";
    masks.cpf = "000.000.000-00";
    masks.cns = "000 0000 0000 0000";
    masks.cnpj = "00.000.000/0000-00";
    masks.creditCardNumber = "0000 0000 0000 0000,";
    masks.date = "00/00/0000";
    masks.monthYear = "00/0000";
    masks.age = "000a00m00d";
    masks.temperature = "00,0";
    masks.pressure = "000/000||00/00||000/00";
    masks.threeDigits = "000||00";
    masks.height = "0,00";
    masks.cnes = "0000000";
    masks.cpfCns = "000.000.000-00||000 0000 0000 0000";
    return masks;
  }

  clearMaskPhone(val: string): string {
    return val.replace('(', '').replace(')', '').replace(' ', '');
  }

  clearMaskCpf(val: string): string {
    return val.replace('.', '').replace('.', '').replace('-', '');
  }

  clearMaskCns(val: string): string {
    return val.replace('.', '').replace('.', '').replace('-', '');
  }

  clearMaskCreditCardNumber(val: string): string {
    return val.replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '');
  }

  clearMaskDate(val: string): Date {
    let aux: string[] = val.split('/');
    return new Date(aux[2] + ' ' + aux[1] + ' ' + aux[0]);
  }
}

export class Masks {
  phone: any;
  cpf: any;
  cns: any;
  cnpj: any;
  creditCardNumber: any;
  date: any;
  monthYear: any;
  temperature: any;
  pressure: any;
  threeDigits: any;
  age: any;
  height: any;
  cnes: any;
  cpfCns: any;
}